import React, { Component } from "react";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import TextSection from "../template/TextSection";
import CardHeader from "@material-ui/core/CardHeader";
import DisplayDecisionTree from "../tree/DisplayDecisionTree";
import CardContent from "@material-ui/core/CardContent";
import ReusableSectionInfo from "./reusable-section/ReusableSectionsInfo";
import Typography from "@material-ui/core/Typography";
export class DisplayTemplateSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      css: {},
    };
  }
  componentDidMount(props) {
    if (this.props.section) {
      this.setState({ css: JSON.parse(this.props.section.css) });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.section != prevProps.section) {
      this.setState({ css: JSON.parse(this.props.section.css) });
    }
  }
  render() {
    let title = {};
    let content = {};
    if (this.state.css && this.state.css.title && this.state.css.title.bold) {
      title.fontWeight = "bold";
    }
    if (this.state.css && this.state.css.title && this.state.css.title.italic) {
      title.fontStyle = "italic";
    }
    if (
      this.state.css &&
      this.state.css.title &&
      this.state.css.title.underline
    ) {
      title.textDecoration = "underline";
    }
    if (
      this.state.css &&
      this.state.css.title &&
      this.state.css.title.fontSize
    ) {
      title.fontSize = this.state.css.title.fontSize;
    }
    if (
      this.state.css &&
      this.state.css.title &&
      this.state.css.title.fontStyle &&
      this.state.css.title.fontGeneric
    ) {
      title.fontFamily =
        this.state.css.title.fontStyle + ", " + title.fontGeneric;
    }
    if (this.state.css && this.state.css.title && this.state.css.title.colour) {
      title.color = this.state.css.title.colour;
    }
    if (
      this.state.css &&
      this.state.css.content &&
      this.state.css.content.colour
    ) {
      content.color = this.state.css.content.colour;
    }
    return (
      <div>
        <CardHeader
          title={
            <Typography component="h2" style={title}>
              {this.props.section.name}
            </Typography>
          }
          disableTypography
          className="template-section-header"
          avatar={
            !this.state.css.visible ? (
              <VisibilityOffIcon
                aria-label="Template section not visible"
                style={{ color: "rgba(0, 0, 0, 0.54)" }}
              />
            ) : null
          }
          action={
            this.props.section.reusableSection && (
              <ReusableSectionInfo
                reusableSection={this.props.section.reusableSection}
              />
            )
          }
        />
        <CardContent id="content">
          {this.props.section.type === "tree" ? (
            <DisplayDecisionTree
              isSection
              node={JSON.parse(this.props.section.defaultText)}
              onRenderComplete={this.props.onRenderComplete}
              sectionId={this.props.section.sectionID}
            />
          ) : (
            <TextSection
              customFields={this.props.customFields}
              isDiff={this.props.isDiff}
              diffSection={this.props.diffSection}
              id="text"
              section={this.props.section}
              onRenderComplete={this.props.onRenderComplete}
            />
          )}
        </CardContent>
      </div>
    );
  }
}
export default DisplayTemplateSection;
